import React from 'react';
import PropTypes from 'prop-types';

import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';

function HomeExperienceSkeleton({ sx, ...other }) {
  return (
    <Stack
      alignItems="center"
      variant="outlined"
      component={Paper}
      sx={{
        py: 5,
        borderRadius: 2,
        textAlign: 'center',
        ...sx,
      }}
      {...other}
    >
      <Skeleton variant="circular" width={50} height={50} />

      <Skeleton variant="text" width={100} height={40} sx={{ mt: 1 }} />

      <Skeleton variant="text" width={80} height={20} sx={{ opacity: 0.64, mt: 1 }} />
    </Stack>
  );
}

HomeExperienceSkeleton.propTypes = {
  sx: PropTypes.object,
};

export default HomeExperienceSkeleton;
